/**
 * TanStack Query hooks for `encryption-posture`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	encryptionPostureQueryKeys,
	type CreateEncryptionPostureBody,
	type ListEncryptionPostureResponse,
	type EncryptionPostureRow,
} from "./api";

export function useEncryptionPostureList(): UseQueryResult<ListEncryptionPostureResponse, Error> {
	return useQuery({
		queryKey: encryptionPostureQueryKeys.list(),
		queryFn: list,
	});
}

export function useEncryptionPostureCreate(): UseMutationResult<EncryptionPostureRow, Error, CreateEncryptionPostureBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: encryptionPostureQueryKeys.all });
		},
	});
}

export function useEncryptionPostureDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: encryptionPostureQueryKeys.all });
		},
	});
}
